import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function calculateUnitPrice(totalPrice: number, quantity: number) {
  if (quantity <= 0 || totalPrice <= 0 || typeof totalPrice !== "number" || typeof quantity !== "number") {
    return 0;
  }

  return Math.round((totalPrice / quantity) * 100) / 100;
}

export function calculateDiscountPercentage(originalPrice: number, discountedPrice: number) {
  if (originalPrice <= 0 || discountedPrice < 0) {
    throw new Error("Prices must be positive values.");
  }

  if (discountedPrice < 1) {
    discountedPrice *= 100;
    originalPrice *= 100;
  }

  const discountAmount = originalPrice - discountedPrice;
  const discountPercentage = (discountAmount / originalPrice) * 100;

  return discountPercentage;
}

export function formatBytes(bytes: number, decimals = 2) {
  if (bytes <= 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const gbInBytes = Math.pow(k, 3);
  const isExactDecimalTB = bytes % (1000 * gbInBytes) === 0 && bytes >= 1000 * gbInBytes;

  if (isExactDecimalTB) {
    const tb = bytes / (1000 * gbInBytes);
    return `${tb} TB`;
  }

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const size = bytes / Math.pow(k, i);

  return `${parseFloat(size.toFixed(dm))} ${sizes[i]}`;
}
